import { Injectable } from '@angular/core';
//import { MenuController } from '@ionic/angular';
import { menuController } from '@ionic/core/components';

import { AlertController } from "@ionic/angular";
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';

import { ProfileService, Types_user } from './profile.service';
import { RolesService, Roles, Permissions } from './roles.service';
import { LanguageService } from './language.service';
import { NotificationsService, Category } from './notifications.service';
import { ChatsService } from './chats.service';
import { ReviewsService, Targets } from './reviews.service';

import $ from 'jquery';
import { Types } from './companies.service';
import { environment } from '../../environments/environment';
import { Badge } from '@capawesome/capacitor-badge';

/* export enum EntityType {
    User = 0,
    Company = 1,
};*/

@Injectable({
    providedIn: 'root',
})

export class UtilsService {

    public language : any;
    public app_opened : boolean = false;
    public default_language : string = 'bg';

    //UI labels: Initialise the labels on the HTML page
    public field_label = {
        menu_profile: "Profile",
        menu_profile_view: "Profile",
        menu_company_view: "Company",
        menu_permissions: "Permissions",
        menu_roles: "Roles",
        menu_users: "Users",
        menu_companies: "Companies",
        menu_admins: "Admins",
        //menu_agents: "Agents",
        //menu_cleaners: "Cleaners",
        menu_team: "Team",
        menu_about: "About",
        menu_sign_out: "Sign out",
        menu_swap_role: "Swap role",
        menu_home: "Home",
        menu_properties: "Properties",
        menu_cleanings: "Cleanings",
        menu_chats: "Chats",
        menu_calendar: "Calendar",
        menu_payments: "Payments",
        menu_customers: "Customers",
        menu_more: "More...",
        ok: "Ok",
        cancel: "Cancel",
        error_title: "Error!",
        unknown_error: "Unknown error. Please login again.",
        unverified_email: "Your email is not verified, please verify it to continue.",
        not_accepted_legal: "You have not accepted the legal documents, please complete your registration.",
        has_no_permission: "User has no permission to do this action. Login again.",
    }

    constructor(
		//public menu: MenuController,
		public alertController: AlertController,
        public router: Router,
        public platform: Platform,
		public profileService : ProfileService,
        public rolesService : RolesService,
        public languageService : LanguageService,
        public notificationsService : NotificationsService,
        public chatsService : ChatsService,
    ) {

        //Translate the labels on the page
        this.translateLabels();
        this.translateMenus();

        //Show/hide menus
        //this.showMenus(this.session);

    }

    getTranslations() {

        if( localStorage.getItem("language") === null ) {
            localStorage.setItem("language", "bg");
        }

        this.languageService.getLanguageDictionary(localStorage.getItem("language") || this.default_language).subscribe((data: any) => {
    
            //console.log("Utils: ", data);
            if (data) {
                //Store in memory
                //localStorage.setItem("translations", JSON.stringify(data.translations));
                localStorage.setItem("translations", data.translations);
            }
        });
    }

    translateLabels() {

        //Android
/*         if (this.platform.is('android')) {
            if (!this.app_opened) {
                //Loop to lose time because Android starts too fast not waiting for device ready!
                console.log("Start");
                for (let i = 0; i < 5000; i++) {
                    //Do nothing
                }
                this.app_opened = true;
                console.log("End");
            }
        }
 */
        this.platform.ready().then(() => {

            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            this.getTranslations();
/*             var language = JSON.parse(localStorage.getItem("translations") || '""');
            if (language != '') {
                this.field_label.error_title = language['error.error_title'];
                this.field_label.ok = language['common.ok'];
                this.field_label.unknown_error = language['login.unknown_error'];
                this.field_label.unverified_email = language['login.unverified_email'];
                this.field_label.not_accepted_legal = language['login.not_accepted_legal'];
            }
 */    
        });
    
    }

    translateMenus(){

        var language = JSON.parse(localStorage.getItem("translations") || '""');

        if (language != '') {

            this.field_label.ok = language['app.common.ok'];
            this.field_label.cancel = language['app.common.cancel'];
            this.field_label.error_title = language['app.error.error_title'];
            this.field_label.unknown_error = language['app.user.unknown_error'];
            this.field_label.unverified_email = language['app.user.unverified_email'];
            this.field_label.not_accepted_legal = language['app.user.not_accepted_legal'];
            this.field_label.has_no_permission = language['app.user.has_no_permission'];

            //Side menu labels
            this.field_label.menu_profile = language['app.user.profile'];
            this.field_label.menu_profile_view = language['app.user.profile_view'];
            this.field_label.menu_company_view = language['app.company.company_view'];
            this.field_label.menu_permissions = language['app.permissions.permissions'];
            this.field_label.menu_roles = language['app.roles.roles'];
            this.field_label.menu_users = language['app.user.users'];
            this.field_label.menu_companies = language['app.company.companies'];
            this.field_label.menu_admins = language['app.admin_company.admins'];
            //this.field_label.menu_agents = language['app.property_company.agents'];
            //this.field_label.menu_cleaners = language['app.cleaning_company.cleaners'];
            this.field_label.menu_team = language['app.common.team'];
            this.field_label.menu_about = language['app.common.about'];
            this.field_label.menu_sign_out = language['app.user.logout'];
            this.field_label.menu_swap_role = language['app.user.swap_role'];
    
            $('.menu-title-profile').text(this.field_label.menu_profile);
            $('.menu-title-profile-view').text(this.field_label.menu_profile_view);
            $('.menu-title-company-view').text(this.field_label.menu_company_view);
            $('.menu-title-permissions-view').text(this.field_label.menu_permissions);
            $('.menu-title-roles-view').text(this.field_label.menu_roles);
            $('.menu-title-users-view').text(this.field_label.menu_users);
            $('.menu-title-companies-view').text(this.field_label.menu_companies);
            $('.menu-title-admins-view').text(this.field_label.menu_admins);
            $('.menu-title-agents-view').text(this.field_label.menu_team);
            $('.menu-title-cleaners-view').text(this.field_label.menu_team);
            $('.menu-title-about').text(this.field_label.menu_about);
            $('.menu-title-profile-signout').text(this.field_label.menu_sign_out);
            $('.menu-title-profile-swap-role').text(this.field_label.menu_swap_role);
    
            //Tabs menu labels
            this.field_label.menu_home = language['app.home.title'];
            this.field_label.menu_properties = language['app.properties.properties'];
            this.field_label.menu_cleanings = language['app.cleanings.cleanings'];
            this.field_label.menu_chats = language['app.chats.chats'];
            this.field_label.menu_calendar = language['app.calendar.calendar'];
            this.field_label.menu_payments = language['app.payments.payments'];
            this.field_label.menu_customers = language['app.company.customers'];
            this.field_label.menu_more = language['app.common.more'];
    
            $('.tab-menu-title-home').text(this.field_label.menu_home);
            $('.tab-menu-title-properties').text(this.field_label.menu_properties);
            $('.tab-menu-title-properties-assigned').text(this.field_label.menu_properties);
            $('.tab-menu-title-cleanings').text(this.field_label.menu_cleanings);
            $('.tab-menu-title-chats').text(this.field_label.menu_chats);
            $('.tab-menu-title-calendar').text(this.field_label.menu_calendar);
            $('.tab-menu-title-payments').text(this.field_label.menu_payments);
            $('.tab-menu-title-customers').text(this.field_label.menu_customers);
            $('.tab-menu-title-more').text(this.field_label.menu_more);
 
        }

    }

    showMenus(session: any){

        //console.log(session);
        
        //Left menu
        $('.menu-profile-view').show();
        if( (this.profileService.canDo(session.permissions, Permissions.CAN_HAVE_ADMIN_COMPANY) || this.profileService.canDo(session.permissions, Permissions.CAN_HAVE_PROPERTY_COMPANY) || this.profileService.canDo(session.permissions, Permissions.CAN_HAVE_CLEANING_COMPANY) )) {
            $('.menu-company-view').show();
        } else {
            $('.menu-company-view').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_CREATE_PERMISSIONS )) {
            $('.menu-permissions-view').show();
        } else {
            $('.menu-permissions-view').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_CREATE_ROLES )) {
            $('.menu-roles-view').show();
        } else {
            $('.menu-roles-view').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_USERS )) {
            $('.menu-users-view').show();
        } else {
            $('.menu-users-view').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_COMPANIES )) {
            $('.menu-companies-view').show();
        } else {
            $('.menu-companies-view').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_ADMIN_COMPANY_USERS )) {
            $('.menu-admins-view').show();
        } else {
            $('.menu-admins-view').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PROPERTY_COMPANY_AGENTS )) {
            $('.menu-agents-view').show();
        } else {
            $('.menu-agents-view').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_CLEANING_COMPANY_CLEANERS )) {
            $('.menu-cleaners-view').show();
        } else {
            $('.menu-cleaners-view').hide();
        }
        $('.menu-about').show();
        $('.menu-profile-signout').show();
/*         if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_OWN_PROFILE) && session.user.multiple_roles) {
            $('.menu-spacer').show();
            $('.menu-profile-swap-role').show();
        } else {
            $('.menu-spacer').hide();
            $('.menu-profile-swap-role').hide();
        } */

        //Bottom menu
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_OWN_PROPERTIES )) {
            $('.tab-menu-properties').show();
        } else {
            $('.tab-menu-properties').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_MANAGED_PROPERTIES ) || this.profileService.canDo(session.permissions, Permissions.CAN_SEE_CLEANED_PROPERTIES )) {
            $('.tab-menu-properties-assigned').show();
        } else {
            $('.tab-menu-properties-assigned').hide();
        }
/*         if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PROPERTY_COMPANY_AGENTS )) {
            $('.tab-menu-agents').show();
        } else {
            $('.tab-menu-agents').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_CLEANING_COMPANY_CLEANERS )) {
            $('.tab-menu-cleaners').show();
        } else {
            $('.tab-menu-cleaners').hide();
        } */

        var show_menu_more : boolean = false;

        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_CLEANINGS) || this.profileService.canDo(session.permissions, Permissions.CAN_SEE_OWN_CLEANINGS)) {
            $('.tab-menu-cleanings').show();
        } else {
            $('.tab-menu-cleanings').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_CALENDAR) ) {
            $('.tab-menu-calendar').show();
            show_menu_more = true;
        } else {
            $('.tab-menu-calendar').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PAYMENTS) && !this.profileService.canDo(session.permissions, Permissions.CAN_SEE_CUSTOMERS)) {
            $('.tab-menu-payments').show();
            show_menu_more = true;
        } else {
            $('.tab-menu-payments').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_CUSTOMERS) && !this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PAYMENTS)) {
            $('.tab-menu-customers').show();
            show_menu_more = true;
        } else {
            $('.tab-menu-customers').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PAYMENTS) && !this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PROVIDERS)) {
            $('.tab-menu-payments').show();
            show_menu_more = true;
        } else {
            $('.tab-menu-payments').hide();
        }
        if( this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PROVIDERS) && !this.profileService.canDo(session.permissions, Permissions.CAN_SEE_PAYMENTS)) {
            $('.tab-menu-providers').show();
            show_menu_more = true;
        } else {
            $('.tab-menu-providers').hide();
        }

        if(show_menu_more) {
            $('.tab-menu-more').show();
        } else {
            $('.tab-menu-more').hide();
        }
    }

/*     checkUserCompletenessAndOpenTabs() {

        if( localStorage.getItem("verified_email") === "false" ) {
            this.confirmOK(this.field_label.error_title, this.field_label.unverified_email, this.field_label.ok);
            //Logout
            //this.openLoginPage();
            this.openResendVerificationLogedInPage();
        } else {

            if( localStorage.getItem("accepted_legal") === "false" ) {
                this.confirmOK(this.field_label.error_title, this.field_label.not_accepted_legal, this.field_label.ok);
                //Logout
                this.openLoginPage();
            } else {

                if( localStorage.getItem("role") === Roles.UNKNOWN ) {
                    //Choose role
                    this.openChooseRolePage();
                } else {
                    //Go to homepage
                    this.openTabsPage();
                }

            }

        }

    }
 */
    checkUserCompletenessAndOpenTabs(session: any) {

        if( !session.user.verified_email ) {
            this.confirmOK(this.field_label.error_title, this.field_label.unverified_email, this.field_label.ok);
            this.openResendVerificationLogedInPage();
        } else {

            if( !session.user.accepted_legal ) {
                this.confirmOK(this.field_label.error_title, this.field_label.not_accepted_legal, this.field_label.ok);
                //Logout
                this.openLoginPage();
            } else {

                if( session.user.role === Roles.UNKNOWN ) {
                    //Choose role
                    this.openChooseRolePage();
                } else {
                    //Go to homepage
                    this.openTabsPage();
                }

            }

        }

    }

/*     checkUserCompleteness() {

        if( localStorage.getItem("verified_email") === "false" ) {
            this.confirmOK(this.field_label.error_title, this.field_label.unverified_email, this.field_label.ok);
            //Logout
            //this.openLoginPage();
            this.openResendVerificationLogedInPage();
        } else {

            if( localStorage.getItem("accepted_legal") === "false" ) {
                this.confirmOK(this.field_label.error_title, this.field_label.not_accepted_legal, this.field_label.ok);
                //Logout
                this.openLoginPage();
            } else {

                if( localStorage.getItem("role") === Roles.UNKNOWN ) {
                    //Choose role
                    this.openChooseRolePage();
                } else {
                    //If is Admin
                    if( localStorage.getItem("role") === Roles.PROPERTY_COMPANY_ADMIN || localStorage.getItem("role") === Roles.CLEANING_COMPANY_ADMIN ) {
                        // But has no company
                        if (!localStorage.getItem("company_id") || localStorage.getItem("company_id") == "0") {
                            //Create company
                            this.openCompanyCreatePage();
                        }
                    }
                }

            }

        }

    }
 */
    checkUserCompleteness(session: any) {

        if( !session.user.verified_email ) {
            this.confirmOK(this.field_label.error_title, this.field_label.unverified_email, this.field_label.ok);
            this.openResendVerificationLogedInPage();
        } else {

            if( !session.user.accepted_legal ) {
                this.confirmOK(this.field_label.error_title, this.field_label.not_accepted_legal, this.field_label.ok);
                //Logout
                this.openLoginPage();
            } else {

                if( session.user.role === Roles.UNKNOWN ) {
                    //Choose role
                    this.openChooseRolePage();
                } else {
                    //If is Admin
                    if( session.user.role === Roles.PROPERTY_COMPANY_ADMIN || session.user.role === Roles.CLEANING_COMPANY_ADMIN ) {
                        // But has no company
                        if (!session.company) {
                            //Create company
                            this.openCompanyCreatePage();
                        }
                    }
                }

            }

        }

    }

	openMenuProfile() {
        //this.menu.enable(true, 'menu-profile');
        //this.menu.open('menu-profile');
        //this.menu.toggle('menu-profile');
/*         console.log(this.menu.get('menu-profile'));
        console.log(this.menu.isOpen('menu-profile'));
        console.log(this.menu.isEnabled('menu-profile'));
        console.log(this.menu.getMenus());
 */        
        menuController.enable(true, 'menu-profile');
        menuController.open('menu-profile');
	}

    replaceLtAndGt(html: string) {
        var html_result: string = ''

        if (html) {
            //Replaces all appearances of "&lt;" and "&gt;" by "<" and ">" 
            html_result = html.replace(/&lt;/gm, "<");
            html_result = html_result.replace(/&gt;/gm, ">");
        }

        return html_result;
    }

    removeHtmlTags(html: string) {
        var html_result: string

        html_result = this.replaceLtAndGt(html);
        html_result = html_result.replace("<b>", "");
        html_result = html_result.replace("</b>", "");
        html_result = html_result.replace("<br/>", "");

        return html_result;
    }

    translateMonth(fieldName: string) {

        var language = JSON.parse(localStorage.getItem("translations") || '""');

        if (language != '') {

        if (fieldName) {
            fieldName = fieldName.replace('January', language['app.dates.months.full.january']);
            fieldName = fieldName.replace('February', language['app.dates.months.full.february']);
            fieldName = fieldName.replace('March', language['app.dates.months.full.march']);
            fieldName = fieldName.replace('April', language['app.dates.months.full.april']);
            fieldName = fieldName.replace('May', language['app.dates.months.full.may']);
            fieldName = fieldName.replace('June', language['app.dates.months.full.june']);
            fieldName = fieldName.replace('July', language['app.dates.months.full.july']);
            fieldName = fieldName.replace('August', language['app.dates.months.full.august']);
            fieldName = fieldName.replace('September', language['app.dates.months.full.september']);
            fieldName = fieldName.replace('October', language['app.dates.months.full.october']);
            fieldName = fieldName.replace('November', language['app.dates.months.full.november']);
            fieldName = fieldName.replace('December', language['app.dates.months.full.december']);
        }
        }

        return fieldName;

    }

    translateMonthShort(fieldName: string) {

        var language = JSON.parse(localStorage.getItem("translations") || '""');

        fieldName = fieldName.replace('Jan', language['common']['month']['short']['jan']);
        fieldName = fieldName.replace('Feb', language['common']['month']['short']['feb']);
        fieldName = fieldName.replace('Mar', language['common']['month']['short']['mar']);
        fieldName = fieldName.replace('Apr', language['common']['month']['short']['apr']);
        fieldName = fieldName.replace('May', language['common']['month']['short']['may']);
        fieldName = fieldName.replace('Jun', language['common']['month']['short']['jun']);
        fieldName = fieldName.replace('Jul', language['common']['month']['short']['jul']);
        fieldName = fieldName.replace('Aug', language['common']['month']['short']['aug']);
        fieldName = fieldName.replace('Sep', language['common']['month']['short']['sep']);
        fieldName = fieldName.replace('Oct', language['common']['month']['short']['oct']);
        fieldName = fieldName.replace('Nov', language['common']['month']['short']['nov']);
        fieldName = fieldName.replace('Dec', language['common']['month']['short']['dec']);

        return fieldName;
    }

    translateDay(fieldName: string) {

        var language = JSON.parse(localStorage.getItem("translations") || '""');

        if (language != '') {
        if (fieldName) {

            fieldName = fieldName.replace('Mon', language['app.dates.days.short.mon']);
            fieldName = fieldName.replace('Tue', language['app.dates.days.short.tue']);
            fieldName = fieldName.replace('Wed', language['app.dates.days.short.wed']);
            fieldName = fieldName.replace('Thu', language['app.dates.days.short.thu']);
            fieldName = fieldName.replace('Fri', language['app.dates.days.short.fri']);
            fieldName = fieldName.replace('Sat', language['app.dates.days.short.sat']);
            fieldName = fieldName.replace('Sun', language['app.dates.days.short.sun']);

        }
        }

        return fieldName;

    }

    translateNotification(fieldName : string, language: any, lang_code: string) {

        fieldName = fieldName.replace(fieldName, language[lang_code + "_" + fieldName]);

        return fieldName;
    }

    //-------------------------------------------
    //-------------------------------------------
    // Location history
    //-------------------------------------------
    //-------------------------------------------

    addLocationHistory(page : string, reset: boolean) {

		//Stores this URL to be able to come back from child pages
		var locationHistory : string;
		var lastlocationHistory : string;

		if (reset) {
			//If Reset then overwrite history
            localStorage.setItem("locationHistory", page);
        } else {
            //Otherwise add the new URL at the end, if not already exist
            lastlocationHistory = this.getLastLocation();
            if (lastlocationHistory !== page) {
                locationHistory = localStorage.getItem("locationHistory") + "," + page;
                localStorage.setItem("locationHistory", locationHistory);
            }
		}

    }

    getLastLocation() {

		//Gets the last URL to be able to compare and not duplicate
		var locationHistory: string;
		var locations : string[];

		locationHistory = localStorage.getItem("locationHistory") || '';
		locations = locationHistory.split(",");
		
		return locations[locations.length-1];

    }

    getPreviousLocation(): string {

		//Gets the previous URL to know where I go
		var locationHistory: string, lastLocation : string[];
		var locations : string[];

		locationHistory = localStorage.getItem("locationHistory") || '';
		locations = locationHistory.split(",");
        //Remove last (current page) and gets its value
        lastLocation = locations.splice(locations.length-1, 1);
		//Remove last (previous page) and gets its value
		lastLocation = locations.splice(locations.length-1, 1);
		
		return lastLocation[0];

    }

    deleteCurrentLocation() {

        //Removes last location from stack
        var locationHistory: string, lastLocation : string[];
        var locations : string[];

        locationHistory = localStorage.getItem("locationHistory") || '';
        locations = locationHistory.split(",");
        //Remove last (current page) and gets its value
        lastLocation = locations.splice(locations.length-1, 1);
        //Stores it
        locationHistory = locations.join(",");
        localStorage.setItem("locationHistory", locationHistory);
        
    }

    isLastLocation(): boolean {

        var locationHistory: string;
        var locations : string[];

        locationHistory = localStorage.getItem("locationHistory") || '';
        locations = locationHistory.split(",");
        if (locations.length > 1) {
            return false;
        }
        return true;
        
    }

    cleanLocalStorage() {

        var language = localStorage.getItem("language") || "bg";

        //Delete all items stored, but we will keep the language
        localStorage.clear();

        localStorage.setItem("language", language);
	}

    //-------------------------------------------
    //-------------------------------------------
    // API correct 
    //-------------------------------------------
    //-------------------------------------------

    dataCorrect(data: any) {

        var correct: boolean = false;

        //console.log("1", data);

        //If session has been lost and can't connect, go to Login
        if (data) {

            correct = true;

            //console.log("2", data);

            if (data.status == "AUTHENTICATION" ) {

                //console.log("3", data);

                //Show error
                this.confirmOK(data.code, data.message, this.field_label.ok).then(result => {

                    if (result) {
                        //Logout
                        this.openLoginPage();
                    }
                })

                correct = false;

            } else {

                if (data.status == "success") {

                    //console.log("4", data.token);

                    if (data.token) {
                        //console.log("4a", data.token);
                        //Set the new token
                        localStorage.setItem("token", data.token);
                    }
    
                    correct = true;
    
                } else {

                    correct = false;
            
                    //console.log("5", data);

                    //Show error
                    if (data.errors) {
                        //console.log("6", data);

                        const values = Object.keys(data.errors).map(key => data.errors[key]);
                        this.confirmOK(this.field_label.error_title, values[0], this.field_label.ok);
                    } else {
                        if (data.message) {
                            //console.log("7", data);

                            this.confirmOK(this.field_label.error_title, data.message, this.field_label.ok);
                        } else {
                            //console.log("8", data);

                            //Unknow error, logoff
                            this.confirmOK(this.field_label.error_title, this.field_label.unknown_error, this.field_label.ok).then(result => {

                                if (result) {
                                    //Logout
                                    this.openLogoutPage();
                                }
                            })
                        }
                    }
                }

            }
        }

        return correct;

    }

    //-------------------------------------------
    //-------------------------------------------
    // Modals 
    //-------------------------------------------
    //-------------------------------------------

    //-------------------------------------------
    // Confirm alert (Yes/No) 
    //-------------------------------------------
    confirmYesNo(title: string, message: string, yes_option: string, no_option: string) {
        return new Promise(
            async (resolve) => {
                (await this.alertController.create({
                    header: title,
                    message: message,
                    buttons: [
                        {
                            text: no_option,
                            role: 'cancel',
                            handler: () => {
                                resolve(false);
                            }
                        },
                        {
                            text: yes_option,
                            handler: () => {
                                resolve(true);
                            }
                        }
                    ]
                })).present();
            }
        );
    }

    //-------------------------------------------
    // Confirm alert (OK) 
    //-------------------------------------------
    confirmOK(title: string, message: string, ok_option: string) {

        return new Promise(
            async (resolve) => {
                (await this.alertController.create({
                    header: title,
                    message: message,
                    buttons: [
                        {
                            text: ok_option,
                            role: 'cancel',
                            handler: () => {
                                resolve(true);
                            }
                        }
                    ]
                })).present();
            }
        );
    }

    //-------------------------------------------
    // Confirm alert (3 options) 
    //-------------------------------------------
    confirmMultiple(title: string, message: string, option1: string, option2: string, option3: string) {
        return new Promise(
            async (resolve) => {
                (await this.alertController.create({
                    header: title,
                    message: message,
                    buttons: [
                        {
                            text: option1,
                            handler: () => {
                                resolve(option1);
                            }
                        },
                        {
                            text: option2,
                            handler: () => {
                                resolve(option2);
                            }
                        },
                        {
                            text: option3,
                            role: 'cancel',
                            handler: () => {
                                resolve(option3);
                            }
                        },
                    ]
                })).present();
            }
        );
    }

    //-------------------------------------------
    // Alert user has no permissions (OK) 
    //-------------------------------------------
    alertNoPermissions() {

        return new Promise(
            async (resolve) => {
                (await this.alertController.create({
                    header: this.field_label.error_title,
                    message: this.field_label.has_no_permission,
                    buttons: [
                        {
                            text: this.field_label.ok,
                            role: 'cancel',
                            handler: () => {
                                resolve(true);
                            }
                        }
                    ]
                })).present();
            }
        );
    }

    //-------------------------------------------
    //-------------------------------------------
    // Routing to pages 
    //-------------------------------------------
    //-------------------------------------------

	goBack() {

        var lastLocation: string;

        //Removes current location
        this.deleteCurrentLocation();
        //Gets last location
        lastLocation = this.getLastLocation();
        //Removes last location
        this.deleteCurrentLocation();

        //Redirects to last location and update location history
        this.router.navigate([decodeURI(lastLocation)]);
	}

	goBackTwice() {

        var lastLocation: string;

        //Removes current location
        this.deleteCurrentLocation();
        //Gets last location
        //lastLocation = this.getLastLocation();
        //Removes last location
        this.deleteCurrentLocation();
        //Gets last location
        lastLocation = this.getLastLocation();
        //Removes last location
        this.deleteCurrentLocation();

        //Redirects to last location and update location history
        this.router.navigate([decodeURI(lastLocation)]);
	}

    openHomePage() {
        this.router.navigate(['/tabs/home']);
    }

    openNotificationsPage() {
        this.router.navigate(['/tabs/notifications']);
    }

    openSearchPage() {
        this.router.navigate(['/tabs/search']);
    }

    openRegistrationPage() {
        this.router.navigate(['/registration']);
    }

    openWelcomePage() {
        this.router.navigate(['/welcome']);
    }

    openLoginPage() {
        this.router.navigate(['/login']);
    }

    openLogoutPage() {
        this.router.navigate(['/logout']);
    }

    openForgotPasswordPage() {
        this.router.navigate(['/forgot-password']);
    }

    openResetPasswordPage(token: any) {
        this.router.navigate(['/reset-password', token]);
    }

    openEditPasswordPage() {
        this.router.navigate(['/tabs/profile/profile-edit-password']);
    }

    openResendVerificationPage() {
        this.router.navigate(['/resend-verification']);
    }

    openResendVerificationLogedInPage() {
        this.router.navigate(['/resend-verification-logedin']);
    }

    openChooseRolePage() {
        this.router.navigate(['/choose-role']);
    }

    openTabsPage() {
        this.router.navigate(['/tabs']);
    }

    openProfilePage(id: any = null) {

        if (!id) {
            this.openProfileViewPage();
        } else {
            this.openCollaboratorsViewPage(id);
        }

    }

    openCompanyPage(id: any = null) {

        if (!id) {
            this.openCompanyViewPage();
        } else {
//            this.openCollaboratorsCompanyViewPage(id);
        }
    }

    openAboutPage() {
        this.router.navigate(['/tabs/profile/about']);
    }

    openUserProfileViewPage(type: Types_user, id: any = "0", property_id: any = "0") {
        this.router.navigate([ '/tabs/profile/profile-view', id, type, property_id ]);
    }

    openProfileViewPage(id: any = "0") {
        this.router.navigate([ '/tabs/profile/profile-view', id, Types_user.USER, 0 ]);
    }

    openProfileEditPage() {
        this.router.navigate([ '/tabs/profile/profile-edit'])
    }

    openProfileDeletePage() {
        this.router.navigate([ '/tabs/profile/profile-delete'])
    }

    openCompaniesPage() {
        this.router.navigate([ '/tabs/companies/companies', Types.All, 0, "XX" ]);
    }

    openRentalCompaniesPage(id: any = "0", country: string = "") {
        this.router.navigate([ '/tabs/companies/companies', Types.Property_Company, id, country ]);
    }

    openCleaningCompaniesPage(id: any = "0", country: string = "") {
        this.router.navigate([ '/tabs/companies/companies', Types.Cleaning_Company, id, country ]);
    }

    openCompanyViewPage(source: string = "APP") {
        this.router.navigate([ '/tabs/companies/company-view', source ]);
    }

    openCompanyShowPage(id: any = "0", type: string = "", property_id: any = "0", allow_request: boolean = false) {
        this.router.navigate([ '/tabs/companies/company-show', id, type, property_id, allow_request]);
    }

    openCompanyCreatePage() {
        this.router.navigate([ '/tabs/companies/company-create'])
    }

    openCompanyEditPage() {
        this.router.navigate([ '/tabs/companies/company-edit'])
    }

    openPermissionsPage() {
        this.router.navigate([ '/tabs/roles/permissions' ]);
    }

    openPermissionPage(id: number) {
        this.router.navigate([ '/tabs/roles/permission-view', id ]);
    }

    openPermissionCreatePage() {
        this.router.navigate([ '/tabs/roles/permission-create']);
    }

    openRolePermissionsAddPage(name: string) {
        this.router.navigate([ '/tabs/roles/role-permissions-add', name]);
    }

    openRolesPage() {
        this.router.navigate([ '/tabs/roles/roles' ]);
    }

    openRolePage(id: number) {
        this.router.navigate([ '/tabs/roles/role-view', id ]);
    }

    openRoleCreatePage() {
        this.router.navigate([ '/tabs/roles/role-create'])
    }

    openReviewsPage(target_type: string, target_id: number) {
        this.router.navigate([ '/tabs/reviews/reviews', target_type, target_id ]);
    }

    openReviewsByCompanyPage(id: number) {
        this.router.navigate([ '/tabs/reviews/reviews-by-company', id ]);
    }

    openReviewCreatePage(target_type: string, target_id: number, entity_type: string = 'NULL', entity_id: any = "0") {
        this.router.navigate([ '/tabs/reviews/review-create', target_type, target_id, entity_type, entity_id ]);
    }

    openReviewViewPage(id: number) {
        this.router.navigate([ '/tabs/reviews/review-view', id ]);
    }

    openReviewEditPage(id: number) {
        this.router.navigate([ '/tabs/reviews/review-edit', id ]);
    }

    openUsersPage() {
        this.router.navigate([ '/tabs/profile/users' ]);
    }

    openAdminsPage() {
        this.router.navigate([ '/tabs/collaborators/collaborators', Types.Admin_Company ]);
    }

    openAgentsPage() {
        this.router.navigate([ '/tabs/collaborators/collaborators', Types.Property_Company ]);
    }

    openCleanersPage() {
        this.router.navigate([ '/tabs/collaborators/collaborators', Types.Cleaning_Company ]);
    }

    openContactsPage() {
        this.router.navigate([ '/tabs/profile/contacts' ]);
    }

    openInvitationsPage() {
        this.router.navigate([ '/tabs/profile/invitations' ]);
    }

    openSwapRolePage() {
        this.router.navigate([ '/tabs/profile/swap-role' ]);
    }

    openCleaningsPage() {
        this.router.navigate([ '/tabs/cleanings/cleanings' ]);
    }

    openCleaningViewPage(id: any) {
        this.router.navigate(['/tabs/cleanings/cleaning-view', id]);
    }

    openCleaningEditPage(id: any) {
        this.router.navigate(['/tabs/cleanings/cleaning-edit', id]);
    }

    openCleaningStartPage(id: any) {
        this.router.navigate(['/tabs/cleanings/cleaning-start', id]);
    }

    openCleaningEndPage(id: any) {
        this.router.navigate(['/tabs/cleanings/cleaning-end', id]);
    }

    openCleaningCommentPage(id: any) {
        this.router.navigate(['/tabs/cleanings/cleaning-comment', id]);
    }

/*     openCleaningPhotosPage(id: number, edit: boolean = false) {
        this.router.navigate( ['/tabs/cleanings/cleaning-photos', id, edit])
    }
 */
    openCollaboratorsViewPage(id: any) {
        this.router.navigate(['/tabs/profile/profile-view', id, Types_user.COLLABORATOR, 0]);
    }

    openRequesterViewPage(id: any) {
        this.router.navigate(['/tabs/profile/profile-view', id, Types_user.REQUESTER, 0]);
    }

    openCleanerViewPage(id: any) {
        this.router.navigate(['/tabs/profile/profile-view', id, Types_user.CLEANER, 0]);
    }

/*     openCollaboratorsCompanyViewPage(id: any) {
        this.router.navigate(['/tabs/collaborators/collaborators-company-view', id]);
    }
 */

    openInvitePage(role: string, company_id: any = "0", property_id: any = "0") {
        this.router.navigate([ '/tabs/collaborators/collaborators-invite', role, company_id, property_id ]);
    }

/*     openAdminsInvitePage() {
        this.router.navigate([ '/tabs/collaborators/collaborators-invite', Roles.ADMIN ]);
    }

    openAgentsInvitePage() {
        this.router.navigate([ '/tabs/collaborators/collaborators-invite', Roles.PROPERTY_COMPANY_AGENT ]);
    }

    openCleanersInvitePage() {
        this.router.navigate([ '/tabs/collaborators/collaborators-invite', Roles.CLEANING_COMPANY_CLEANER ]);
    }

    openOwnersInvitePage() {
        this.router.navigate([ '/tabs/collaborators/collaborators-invite', Roles.PROPERTY_OWNER ]);
    }

    openCoownersInvitePage() {
        this.router.navigate([ '/tabs/collaborators/collaborators-invite', "PROPERTY_COOWNER" ]);
    }

    openTenantsInvitePage() {
        this.router.navigate([ '/tabs/collaborators/collaborators-invite', Roles.PROPERTY_TENANT ]);
    }
 */
    openCleanersAssignPage(cleaning_id : number) {
        this.router.navigate([ '/tabs/collaborators/cleaners-assign', cleaning_id ]);
    }

    openCompanyPicturePage(id: any, edit: boolean = true) {
        this.router.navigate([ '/tabs/profile-view/profile-picture', "Companies", id, edit])
    }

    openCleaningCreatePage(property_id: number, company_id: number, year: number = 0, month: number = 0, day: number = 0) {
        this.router.navigate([ '/tabs/cleanings/cleaning-create', property_id, company_id, year, month, day])
    }

    openPropertiesPage() {
        this.router.navigate(['/tabs/properties/properties']);
    }

    openPropertiesAssignedPage() {
        this.router.navigate(['/tabs/properties/properties-assigned']);
    }

    openPropertyViewPage( id: number, type: string = Types.All, management_id: any = "0", is_request: boolean = false ) {
        this.router.navigate(['/tabs/properties/property-view', id, type, management_id, is_request]);
    }

    openPropertyCreatePage() {
        this.router.navigate(['/tabs/properties/property-create']);
    }

    openPropertyEditPage( id: number ) {
        this.router.navigate(['/tabs/properties/property-edit', id]);
    }

    openPropertyDeletePage( id: number ) {
        this.router.navigate(['/tabs/properties/property-delete', id]);
    }

/*     openPropertyPhotosPage(id: number, edit: boolean = false) {
        this.router.navigate( ['/tabs/properties/property-photos', id, edit])
    }
 */
/*     openProfilePhotoPage(type: string = "avatar", edit: boolean = false, url: string = "", name: string = "") {
        this.router.navigate( ['/tabs/profile/profile-photo', type, edit, url, name])
    }
 */
/*     openProfilePhotosPage(type: string = "avatar", edit: boolean = false) {
        this.router.navigate( ['/tabs/profile/profile-photos', type, edit])
    }
 */
    openPhotosPage(type: string, id: number, edit: boolean = false, skip: boolean = false) {
        this.router.navigate( ['/tabs/photos/photos', type, id, edit, skip])
    }

    openPhotoPage(type: string, id: number, edit: boolean = false, available: number = 0, skip: boolean = false) {
        this.router.navigate( ['/tabs/photos/photo', type, id, edit, available, skip], { replaceUrl: true })
        // replaceUrl drops this page from the Ionic history stack immediately
        // Used because when coming back twice (with skip=true) it was automatically redirecting you again to this page
    }

    openManagementServicesCreatePage( token: string ) {
        this.router.navigate(['/tabs/properties/management-services-create', token]);
    }

    openManagementServicesViewPage( id: number ) {
        this.router.navigate(['/tabs/properties/management-services-view', id]);
    }

    openCleaningServicesCreatePage( token: string ) {
        this.router.navigate(['/tabs/properties/cleaning-services-create', token]);
    }

    openCleaningServicesViewPage( id: number ) {
        this.router.navigate(['/tabs/properties/cleaning-services-view', id]);
    }

    openCleaningServicesEditPage( id: number ) {
        this.router.navigate(['/tabs/properties/cleaning-services-edit', id]);
    }

    openCalendarPage(id: any = "0", allow_back:boolean = false) {
        this.router.navigate(['/tabs/calendars/calendar', id, allow_back]);
    }

    openCalendarDayPage(year: number, month: number, day: number, property_id: any = "0") {
        this.router.navigate(['/tabs/calendars/calendar-day', year, month, day, property_id]);
    }

    openCalendarPropertiesSelectPage() {
        this.router.navigate(['/tabs/calendars/calendar-properties-select']);
    }

    openPaymentsPage() {
        this.router.navigate([ '/tabs/payments/payments'])
    }

    openPaymentCreatePage(user_id: any = "0", property_id: any = "0", cleaning_id: any = "0") {
        this.router.navigate([ '/tabs/payments/payment-create', user_id, property_id, cleaning_id])
    }

    openPaymentViewPage( id: any ) {
        this.router.navigate(['/tabs/payments/payment-view', id]);
    }

    openPaymentEditPage( id: any ) {
        this.router.navigate(['/tabs/payments/payment-edit', id]);
    }

    openPaymentStripeViewPage( id: any, type: string ) {
        this.router.navigate(['/tabs/payments/payment-stripe-view', id, type]);
    }

    openPaymentActivationStripeViewPage( ) {
        this.router.navigate(['/tabs/payments/payment-activation-stripe-view']);
    }

    openCustomersPage() {
        this.router.navigate([ '/tabs/customers/customers' ]);
    }

    openCustomersViewPage(id: any) {
        this.router.navigate(['/tabs/profile/profile-view', id, Types_user.CUSTOMER, 0]);
    }

    openProvidersPage() {
        this.router.navigate([ '/tabs/providers/providers' ]);
    }

    openProvidersViewPage(id: any) {
        this.router.navigate(['/tabs/profile/profile-view', id, Types_user.PROVIDER, 0]);
    }

    openOwnerViewPage(property_id: number, owner_id: number) {
        this.router.navigate(['/tabs/profile/profile-view', owner_id, Types_user.OWNER, property_id]);
    }

    openTenantViewPage(property_id: number, tenant_id: number) {
        this.router.navigate(['/tabs/profile/profile-view', tenant_id, Types_user.TENANT, property_id]);
    }

    openSendEmailPage(id: number) {
        this.router.navigate(['/tabs/profile/send-email', id]);
    }

    openChatViewPage( id: any = "0", receiver_id: any = "0" ) {
        this.router.navigate(['/tabs/chats/chat-view', id, receiver_id]);
    }

    openChatsPage() {
        this.router.navigate(['/tabs/chats/chats']);
    }

    //-------------------------------------------
    //-------------------------------------------
    // Roles 
    //-------------------------------------------
    //-------------------------------------------

/*     isCBZNAdmin() : boolean {
        return localStorage.getItem("role") === Roles.CBZNAdmin;
    }

    isCBZNUser() : boolean {
        return localStorage.getItem("role") === Roles.CBZNUser;
    }

    isCompanyAdmin() : boolean {
        return localStorage.getItem("role") === Roles.CompanyAdmin;
    }

    isCompanyUser() : boolean {
        return localStorage.getItem("role") === Roles.CompanyUser;
    }

    getRoles() : any {

        var language = JSON.parse(localStorage.getItem("translations") || '""');

		//Available roles
        var roles = [];
        if (this.isCBZNAdmin()) {
            roles.push({code: Roles.CBZNAdmin, name: language['roles'][Roles.CBZNAdmin]});
            roles.push({code: Roles.CBZNUser, name: language['roles'][Roles.CBZNUser]});
        }
        if (this.isCompanyAdmin()) {
            roles.push({code: Roles.CompanyAdmin, name: language['roles'][Roles.CompanyAdmin]});
            roles.push({code: Roles.CompanyUser, name: language['roles'][Roles.CompanyUser]});
        }

        return roles;

    }
 */
    //-------------------------------------------
    //-------------------------------------------
    // Other 
    //-------------------------------------------
    //-------------------------------------------

/*     setRefreshFlags(notification: any) {

        var url = notification.additionalData.url.toString();
        url = url.replace(/['"]+/g, '');

        console.log("URL=", url);
    
        if (url !== '') {
    
            //Posts
            if (url.includes('/app/index.php/posts')) {
                var index = url.indexOf("view_post/");
                var id = url.substring(index + 10); 
                var cur_ids = localStorage.getItem("refresh_posts");
                var new_ids = cur_ids + "," + id;
                localStorage.setItem("refresh_posts", new_ids);
            }
        
            //Events
            if (url.includes('/app/index.php/events')) {
                var index = url.indexOf("show/");
                var id = url.substring(index + 5); 
                var cur_ids = localStorage.getItem("refresh_events");
                var new_ids = cur_ids + "," + id;
                localStorage.setItem("refresh_events", new_ids);
            }
        
            //Chats
            if (url.includes('/app/index.php/conversations')) {
                var index = url.indexOf("view_conversation/");
                var id = url.substring(index + 18); 
                var cur_ids = localStorage.getItem("refresh_conversations");
                var new_ids = cur_ids + "," + id;
                localStorage.setItem("refresh_conversations", new_ids);
            }
        
            //Spaces
            if (url.includes('/app/index.php/spaces')) {
                var index = url.indexOf("?");
                var params_str = url.substring(index + 1); 
                var params = params_str.split("&");
                var id: any = "";
                params.forEach(function (value: string) {
                    var param = value.split("=");
                    if (param[0] === "space") {
                        id = param[1];
                    }
                });
                var cur_ids = localStorage.getItem("refresh_spaces");
                var new_ids = cur_ids + "," + id;
                localStorage.setItem("refresh_spaces", new_ids);
            }
        
            //Albums
            if (url.includes('/app/index.php/albums')) {
                var index = url.indexOf("?");
                var params_str = url.substring(index + 1); 
                var params = params_str.split("&");
                var id: any = "";
                params.forEach(function (value: string) {
                    var param = value.split("=");
                    if (param[0] === "album") {
                        id = param[1];
                    }
                });
                var cur_ids = localStorage.getItem("refresh_albums");
                var new_ids = cur_ids + "," + id;
                localStorage.setItem("refresh_albums", new_ids);
            }
        
        }

    }
 */
/*     refreshFlag(entityType: EntityType, entityId: any = -1): boolean {

        var refresh = false;

        switch (entityType) {
            case EntityType.Post: {refresh = this.isIdInFlag("refresh_posts", entityId); break;}
            case EntityType.Event: {refresh = this.isIdInFlag("refresh_events", entityId); break;}
            case EntityType.Space: {refresh = this.isIdInFlag("refresh_spaces", entityId); break;}
            case EntityType.Album: {refresh = this.isIdInFlag("refresh_albums", entityId); break;}
            case EntityType.Conversation: {refresh = this.isIdInFlag("refresh_conversations", entityId); break;}
        }

        // Clear all flags after a page requeted flags
        this.clearFlags();

        return refresh;
    }
 */
/*     isIdInFlag(flag: string, entityId: any): boolean {

        var exist = false;

        var cur_ids = localStorage.getItem(flag);

        if (cur_ids) {

            //Id is optional, check only if passed
            if (+entityId === -1) {
                exist = true;
            } else {

                var ids = cur_ids.split(",");

                for (let id of ids) {
                    if (+id === +entityId) {
                        exist = true;
                        break;
                    }
                }
            }

        }

        return exist;
    }

    clearFlags() {
        localStorage.removeItem("refresh_posts");
        localStorage.removeItem("refresh_events");
        localStorage.removeItem("refresh_spaces");
        localStorage.removeItem("refresh_albums");
        localStorage.removeItem("refresh_conversations");
    }
 */
    updateNotificationsCounter() {

	    var token = localStorage.getItem("token") || "";

		this.notificationsService.getNotificationsCounter( token ).subscribe((data: any) => {

            //If data returned is not correct or has code AUTHENTICATION, logout
            if (this.dataCorrect(data)) {

                //Save number
                //localStorage.setItem("notifications", data.notifications);
                environment.notifications_counter = data.notifications;
                //Show
                this.showNotificationsCounter();

            }
        });

		this.chatsService.getMessagesCounter( token ).subscribe((data: any) => {

            //If data returned is not correct or has code AUTHENTICATION, logout
            if (this.dataCorrect(data)) {

                //Save number
                environment.messages_counter = data.messages;
                //Show
                this.showNotificationsCounter();

            }
        });

    }

    showNotificationsCounter() {

	   // var notifications = +(localStorage.getItem("notifications") || "0");

        //Mobile
        //BADGE works only when app is open and is called by the timer set in Home
        //To refresh when is closed:
        //-- iOS we pass the 'badge' param in the payload of the notification and is automatically refreshed
        //-- Android can't do it, we pass a para in 'data' section and we need a Java program to make it run in background mode
        //There is a possibility to add Capacitor backgroun runner library, to run the app in background, but it consumes a lot of battery, not recommended
        if ((window as any).cordova) {
            // Request permission to show badges (required on some platforms)
            Badge.requestPermissions();
        }
//console.log(environment.notifications_counter);
        if (environment.notifications_counter > 0) {
//            $('.notifications-outline').html('<span' + (this.profileService.hasCompany() ? ' style="right: 100px"' : '') + '>' + notifications + '</span>');
    
            //Shows the number inside the app in menu on top
            $('.notifications-outline').html('<span' + (this.profileService.hasCompany() ? ' style="right: 100px"' : '') + '>' + environment.notifications_counter + '</span>');

            //Mobile
            if ((window as any).cordova) {
                //Shows the number in the app icon
                Badge.set({ count: environment.notifications_counter });
            }
        }
        if (environment.notifications_counter == 0) {

            //Clears notifications on top
            $('.notifications-outline span').remove();

            //Mobile
            if ((window as any).cordova) {
                //Clears the number in the app icon
                Badge.clear(); // Removes the badge
            }

        }

        //Shows the number inside the app in menu on bottom
        if (environment.messages_counter > 0) {
            $('.messages-outline').html('<span>' + environment.messages_counter + '</span>');
        }
        if (environment.messages_counter == 0) {
            $('.messages-outline span').remove();
        }

/*         const isSupported = async () => {
            const result = await Badge.isSupported();
            return result.isSupported;
        };
        console.log("Badge", await Badge.isSupported());

        const get = async () => {
            const result = await Badge.get();
            return result.count;
        };
        console.log("Badge number", await Badge.get()); */
    }

    destroyTasks() {

        //Notifications
        var id = +(localStorage.getItem("task_notifications") || 0);
        clearInterval(id);
        localStorage.removeItem("task_notifications");

        //Chat messages
        id = +(localStorage.getItem("task_chat_messages") || 0);
        clearInterval(id);
        localStorage.removeItem("task_chat_messages");

    }

    //-------------------------------------------------------------------------------------------------------------------------------
    // ONESIGNAL - NOTIFICATIONS
    //-------------------------------------------------------------------------------------------------------------------------------
/*     OneSignalInit() {

        try {

            // Initialise OneSignal -----------------------------------------------
            // App Id for MopCorner
            console.log('onesignal_key; ', environment.onesignal_key);
            OneSignal.setAppId(environment.onesignal_key);

    } catch(error) {
        console.log(JSON.stringify(error));
    }

  }
 */

    redirectNotification(type: string, link: any = null) {

		const token: string = localStorage.getItem("token") || "";
        var session: any;
        var current_user: any = "0";
        var current_company: any = "0";
        var current_role: string = "";

		this.profileService.getSession(token).subscribe((data: any) => {
		
			if (this.dataCorrect(data)) {

				session = data;
                current_user = session.user.id;
                current_role = session.user.role;
                if (session.company) {
                    current_company = (session.company.id || "0");
                }

			}

		});
            
        //Link
        var link_params: any;
        if (link) {
            link_params = JSON.parse(link);
            console.log("Link:", link);
            console.log("Params:", link_params);
        }

		//Navigates to destiny
		switch (type) {
			case Category.PROPERTY_RENTAL_ENDED:
			case Category.REQUEST_MANAGEMENT_SERVICES_RECEIVED:
			case Category.REQUEST_MANAGEMENT_SERVICES_CANCELLED:
			case Category.PROPERTY_MANAGEMENT_STOPPED:
			case Category.REQUEST_CLEANING_SERVICES_RECEIVED:
			case Category.REQUEST_CLEANING_SERVICES_CANCELLED:
			case Category.PROPERTY_CLEANING_STOPPED:
				{
					if (link) {
						this.openPropertyViewPage(link_params.property_id, link_params.type, link_params.cleaning_request_id, link_params.request);
					} else {
						this.openPropertiesAssignedPage(); 
					}
					break;
				}
			case Category.REQUEST_MANAGEMENT_SERVICES_ACCEPTED:
			case Category.REQUEST_MANAGEMENT_SERVICES_REJECTED:
			case Category.PROPERTY_CLEANING_MODIFIED:
			case Category.REQUEST_CLEANING_SERVICES_ACCEPTED:
			case Category.REQUEST_CLEANING_SERVICES_REJECTED:
				{
					//Property owner
					if (current_role === Roles.PROPERTY_OWNER) {
                        if (link) {
                            this.openPropertyViewPage(link_params.property_id, link_params.type, link_params.cleaning_request_id, link_params.request);
                        } else {
    						this.openPropertiesPage(); 
                        }
					}
					//Rental company
					if (current_role === Roles.PROPERTY_COMPANY_ADMIN) {
                        if (link) {
                            this.openPropertyViewPage(link_params.property_id, link_params.type, link_params.cleaning_request_id, link_params.request);
                        } else {
    						this.openPropertiesAssignedPage(); 
                        }
					}
					break;
				}
			case Category.REQUEST_CLEANING_RECEIVED:
			case Category.REQUEST_CLEANING_MODIFIED:
			case Category.REQUEST_CLEANING_CANCELLED:
			case Category.REQUEST_CLEANING_ASSIGNED:
			case Category.REQUEST_CLEANING_STARTED:
			case Category.REQUEST_CLEANING_ENDED:
			case Category.REQUEST_CLEANING_RECURRENCE_STOPPED:
			case Category.REQUEST_CLEANING_COMMENTED:
				{
					if (link) {
						this.openCleaningViewPage(link_params.id);
					} else {
						this.openCleaningsPage(); 
					}
					break;
				}
			case Category.INVITATION_RECEIVED:
			case Category.INVITATION_ACCEPTED:
			case Category.INVITATION_REJECTED:
				{
					//Rental company
					if (current_role === Roles.PROPERTY_COMPANY_ADMIN) {
						this.openAgentsPage(); 
					} else if (current_role === Roles.CLEANING_COMPANY_ADMIN) {
						//Cleaning company
						this.openCleanersPage(); 
					} else {
						//Others
						this.openInvitationsPage(); 
					}
					break;
				}
			case Category.REQUEST_PAYMENT_RECEIVED:
			case Category.REQUEST_PAYMENT_REJECTED:
			case Category.REQUEST_PAYMENT_UPDATED:
			case Category.REQUEST_PAYMENT_ENDED:
			case Category.REQUEST_PAYMENT_PAID:
				{
					if (link) {
						this.openPaymentViewPage(link_params.id);
					} else {
						this.openPaymentsPage(); 
					}
					break;
				}
			case Category.REVIEW_CREATED:
			case Category.REVIEW_UPDATED:
			case Category.REVIEW_DELETED:
				{
					if (link) {
						this.openReviewViewPage(link_params.id);
					} else {
    					this.openReviewsPage(Targets.USER, current_user);
					}
					break;
				}
			case Category.REVIEW_CREATED_ADMIN:
			case Category.REVIEW_UPDATED_ADMIN:
			case Category.REVIEW_DELETED_ADMIN:
				{
					if (link) {
						this.openReviewViewPage(link_params.id);
					} else {
    					this.openReviewsByCompanyPage(current_company); 
					}
					break;
				}
			case Category.CHAT_CREATED:
				{
					if (link) {
						this.openChatViewPage(link_params.id);
					} else {
    					this.openChatsPage();
					}
					break;
				}
		}

    }
}